"use client";

import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useTranslations } from "next-intl";

export function BusinessListSort<T extends string>({
  options,
  value,
  onChange,
}: {
  options: readonly T[];
  value: T;
  onChange: (value: T) => void;
}) {
  const t = useTranslations();

  return (
    <div className="hidden shrink-0 items-center gap-2 md:flex">
      <Label className="shrink-0 text-muted-foreground">
        {t("saas.search.sort.label")}
      </Label>

      <Select
        onValueChange={(val) => onChange(val as T)}
        value={value as string}
      >
        <SelectTrigger className="h-11 min-w-[176px]">
          {t(`saas.search.sort.options.${value}` as any)}
        </SelectTrigger>

        <SelectContent>
          {options.map((value) => (
            <SelectItem key={value} value={value}>
              {t(`saas.search.sort.options.${value}` as any)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

BusinessListSort.displayName = "BusinessListSort";
